import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { clearfix, toVw, col, toVwTablet, link, linkChangeColor } from '../utils/styles';
import { LARGE_COL_WIDTH } from '../constants';
import mq from '@/utils/media-queries';
import LinkFade from './LinkFade';
import api from '../utils/api';

const SEQUENCE_DESKTOP = [5, 3, 2];

const Styled = styled.div`
  ${clearfix};
`;

const SmallLinksCol = styled.div`
  ${col};

  &:first-child {
    width: ${toVw(LARGE_COL_WIDTH)};
  }

  &:nth-child(2) {
    width: ${toVw(360)};
  }

  &:last-child {
    padding-right: 0;
  }

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(104)};

    &:first-child {
      width: ${toVwTablet(256)};
    }

    &:nth-child(2) {
      width: auto;
    }

    &:last-child {
      margin-bottom: 0;
      width: 100%;
    }
  `)};
`;

const SmallLink = styled.div`
  margin-bottom: 1px;
`;

const linkBase = css`
  ${link};
  ${props => linkChangeColor(props.theme.colorText)};
`;

const SmallLinkInner = styled.a`
  ${linkBase};
`;

const SmallLinkInnerLocal = styled(LinkFade)`
  ${linkBase};
`;

class Links extends React.PureComponent {
  state = {
    links: [],
  };

  componentDidMount() {
    api.links().then(async body => {
      const links = await body.json();
      this.setState({ links });
    });
  }

  render() {
    let prevMaxNum = 0;

    return (
      <Styled {...this.props}>
        {SEQUENCE_DESKTOP.map((maxNum, index) => {
          const col = (
            <SmallLinksCol key={index}>
              {this.state.links.slice(prevMaxNum, prevMaxNum + maxNum).map((link, itemIndex) => (
                <SmallLink key={itemIndex} data-test="small-link">
                  {link.local ? (
                    <SmallLinkInnerLocal to={link.link}>{link.title}</SmallLinkInnerLocal>
                  ) : (
                    <SmallLinkInner href={link.link} target="_blank">
                      {link.title}
                    </SmallLinkInner>
                  )}
                </SmallLink>
              ))}
            </SmallLinksCol>
          );
          prevMaxNum = prevMaxNum + maxNum;
          return col;
        })}
      </Styled>
    );
  }
}

Links.propTypes = {
  className: PropTypes.string,
  onLinkClick: PropTypes.func,
};

export default Links;



// WEBPACK FOOTER //
// ./src/components/Links.js